import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d297d2ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "icon"
}
const _hoisted_3 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "icon" }

import { computed, ComputedRef, ref } from 'vue';
import IconComponent from './icon/IconComponent.vue';
import Icon from './icon/Icon';

type DropdownBoxIconType = 'complete' | 'active';


export default /*#__PURE__*/_defineComponent({
  __name: 'InteractiveCheckBox',
  props: {
    complete: { type: Boolean },
    active: { type: Boolean },
    userSelectedComplete: { type: Boolean },
    userSelectedActive: { type: Boolean },
    compromised: { type: Boolean }
  },
  emits: ["dropdownItemClick"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'dropdownItemClick', arg1: DropdownBoxIconType): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  complete: boolean;
  active: boolean;
  userSelectedComplete: boolean;
  userSelectedActive: boolean;
  compromised: boolean;
}





const showDropdown = ref(false);

const stateOptions: ComputedRef<['complete', 'active']> = computed(() => {
  return ['complete', 'active'];
});

const checkBoxIcon = computed(() => {
  if (props.complete) {
    return Icon.WHITE_CHECK;
  } else if (props.userSelectedActive) {
    return Icon.SELECT_O;
  } else {
    return Icon.WHITE_CHECK;
  }
});

const dropdownBoxIcon = (value: DropdownBoxIconType) => {
  if (value === 'complete') {
    return Icon.WHITE_CHECK;
  } else if (value === 'active') {
    return Icon.SELECT_O;
  } else {
    return null;
  }
};

const handleBodyClick = (event?: MouseEvent) => {
  // add window click listener to see if user clicks outside of dropdown, if so, close dropdown
  event && event.stopPropagation();

  if (event && !showDropdown.value) {
    window.addEventListener('click', () => {
      if (event.target !== event.currentTarget) {
        showDropdown.value = false;
      }
    });
  } else if (event && showDropdown.value) {
    window.removeEventListener('click', () => {
      if (event.target !== event.currentTarget) {
        showDropdown.value = false;
      }
    });
  }

  if (!showDropdown.value) {
    showDropdown.value = true;
  } else {
    showDropdown.value = false;
  }
};

const handleDropdownItemClick = (value: 'complete' | 'active') => {
  emit('dropdownItemClick', value);
  handleBodyClick();
};

const quality = computed(() => {
  if (
    (props.userSelectedActive ||
      props.userSelectedComplete ||
      props.complete) &&
    !props.compromised
  ) {
    return 'full';
  } else if (
    props.userSelectedActive ||
    props.userSelectedComplete ||
    (props.complete && !props.userSelectedComplete && props.compromised)
  ) {
    return 'reduced';
  } else {
    return 'default';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["body", _unref(quality)]),
      onClick: _cache[0] || (_cache[0] = (event) => handleBodyClick(event))
    }, [
      (__props.complete || __props.userSelectedComplete || __props.userSelectedActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(IconComponent, { icon: _unref(checkBoxIcon) }, null, 8, ["icon"])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (showDropdown.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stateOptions), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "body full",
              key: item,
              onClick: ($event: any) => (handleDropdownItemClick(item))
            }, [
              _createElementVNode("div", _hoisted_5, [
                (dropdownBoxIcon(item))
                  ? (_openBlock(), _createBlock(IconComponent, {
                      key: 0,
                      icon: (dropdownBoxIcon(item) as Icon)
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})